import * as React from "react";
const SvgUpArrow = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 44 44", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.15 30.75 12 28.6 24 16.6 36 28.55 33.85 30.7 24 20.85Z" }));
export default SvgUpArrow;
